<template>
  <header>
    <template v-if="type === 'default'">
      <h1 class="header-logo">
        <img src="../assets/images/logo.png" alt="DGB대구은행">
      </h1>
    </template>
    <template v-if="type === 'title'">
      <span class="btn-back">
        <img src="../assets/images/btn_back.png" alt="뒤로가기">
      </span>
      <h1 class="header-title">
        {{ title }}
      </h1>
    </template>
  </header>
</template>
<script>
export default {
  name: 'AppHeader',
  props: {
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppHeader.vue